<template>
	<!-- <div class="branch-container"> -->
	<div class="notifcation">
		<header class="head"><span>消息通知</span></header>
		<div class="box">
			<div class="notifcation_main">
				<div class="nav">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane class="tab" label="全部" name="-1"></el-tab-pane>
						<el-tab-pane class="tab" label="已读" name="1"></el-tab-pane>
						<el-tab-pane class="tab" label="未读" name="0"></el-tab-pane>
					</el-tabs>
					<div class="right">
						<!-- <button class="btn active" @click="getInfos">一键已读</button> -->
						<el-button
							type="danger"
							@click="getInfos"
							plain
							size="small"
							v-show="infoList.length != 0"
							>一键已读</el-button
						>
					</div>
				</div>

				<div class="content">
					<div class="no_info" v-if="infoList.length == 0">暂无数据</div>
					<div class="info_item" v-for="(item, index) in infoList" :key="item.id">
						<div class="info_content">
							<span @click="drawerClick(index, item.id, item.type, item.pid)">{{
								item.title
							}}</span>
							<!-- 未读信息标识 -->
							<div class="sign_box" v-show="item.read_type == 0"></div>
						</div>
						<div class="info_right">
							<div class="timer">{{ item.createtime }}</div>
							<div class="info_btn">
								<el-button
									class="el_btn"
									@click="drawerClick(index, item.id, item.type, item.pid)"
									type="primary"
								>
									{{ ckxq }}
								</el-button>
							</div>
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div class="footer" v-if="infoList.length != 0">
					<el-pagination
						background
						layout="prev, pager, next,sizes,jumper"
						:total="total"
						:current-page="currentPage"
						:page-size="pageSize"
						:page-sizes="[10, 20, 30]"
						@size-change="sizeChange"
						@current-change="currentChange"
					>
					</el-pagination>
				</div>

				<!-- 弹出框内容 -->
				<el-drawer title="消息详情" :visible.sync="drawer" :with-header="false" :size="650">
					<div class="drawer">
						<div class="header">
							<span>消息详情</span>
							<div class="shut" @click="drawer = false">
								<i class="el-icon-close"></i>
							</div>
						</div>
						<div class="mian">
							<div class="title">{{ infoDetailData.title }}</div>
							<div class="timer">{{ infoDetailData.createtime }}</div>
							<div class="content" v-html="infoDetailData.content"></div>
						</div>
					</div>
				</el-drawer>
			</div>
		</div>
	</div>
</template>

<script>
	import { $infoList, $infoNew, $infoDetails, $infoRead } from '@/api/index.js';
	export default {
		data() {
			return {
				activeName: '-1', // 消息分类索引
				active: '',
				type: undefined,
				typeItem: [
					{ type: 0, title: '全部' },
					{ type: '1', title: '已读' },
					{ type: '0', title: '未读' },
				],
				ckxq: '查看详情',
				infoList: [], // 消息列表
				infoDetailData: {}, // 消息详情
				show: 0,
				drawer: false, // 弹出框
				total: 0, // 总条数
				currentPage: 1, // 当前页数
				pageSize: 10, // 每页显示条数

				timers: null,
				timersState: false,

				// 是否有新消息
				news_state: false,
			};
		},
		created() {
			this.getInfoList();

			this.getTimerData(); // 轮训
		},
		updated() {
			if (this.timersState) {
				clearInterval(this.timers);
				this.timersState = false;
			}
			this.getTimerData(); // 轮训
		},

		beforeRouteLeave(to, from, next) {
			// 离开页面 停止轮训
			if (this.timersState) {
				clearInterval(this.timers);
				this.timersState = false;
			}
			next();
		},
		methods: {
			// // 获取消息列表
			// getInfoList(page = "1", rows = "10", type) {
			//   let params = {
			//     page,
			//     rows,
			//   };
			//   type != undefined && type != "-1" ? (params["type"] = type) : "";
			//   // console.log('参数',params);

			//   $infoList(params)
			//     .then((res) => {
			//       // console.log('消息列表', res);
			//       this.infoList = res.data.rows;

			//       this.total = res.data.total.total;
			//       this.currentPage = res.data.total.current_page;
			//     })
			//     .catch((err) => {
			//       console.log(err);
			//     });
			// },

			// 获取消息列表
			getInfoList(params) {
				params
					? ''
					: (params = {
							page: '1',
							rows: '10',
					  });
				$infoList(params)
					.then((res) => {
						// console.log('消息列表', res);
						this.infoList = res.data.rows;

						this.total = res.data.total.total;
						this.currentPage = res.data.total.current_page;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 获取最新消息
			getInfoNew() {
				$infoNew()
					.then((res) => {
						if (res.data.unread_type) {
							this.getInfoList();
							this.news_state = true;
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 获取消息详情
			getInfoDetails(pid) {
				$infoDetails({ id: pid })
					.then((res) => {
						// console.log('获取消息列表', res);
						this.infoDetailData = res.data;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 轮训方法
			getTimerData() {
				this.timersState = true;
				this.timers = setInterval(() => {
					this.getInfoNew();
				}, 30000);
			},

			// 分类导航
			handleClick(tab, event) {
				this.type = tab.name != -1 ? tab.name : undefined;
				this.pageSize = 10;
				this.currentPage = 1;

				this.sendData();
			},

			// 一键已读
			getInfos() {
				$infoRead()
					.then((res) => {
						// console.log('一键已读', res);

						this.news_state = false;
						this.getInfoList();
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 点击查看详情
			drawerClick(index, id, type, pid) {
				// console.log('id', pid);
				this.infoList[index].read_type = 1; // 修改阅读状态
				if (type == 1) {
					this.drawer = true;
					this.getInfoDetails(id);
				} else if ((type = 2)) {
					// 订单消息
					// this.getInfoDetails(id);
					this.$router.push({
						path: '/orderdetails',
						query: {
							id: window.btoa(pid),
						},
					});
				}
			},

			// 每页条数改变触发
			sizeChange(pageSize) {
				this.pageSize = pageSize;
				this.currentPage = 1;
				this.sendData();
			},
			// 页码改变触发
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.sendData();
			},

			sendData() {
				let params = {
					page: this.currentPage,
					rows: this.pageSize,
					type: this.type ? this.type : undefined,
				};
				this.getInfoList(params);
			},
		},
	};
</script>

<style lang="scss" scoped>
	// .branch-container{
	.notifcation {
		min-width: 845px;
		height: 100%;
		.head {
			width: 100%;
			height: 64px;
			// min-width: 1100px;
			background: #ffffff;
			padding: 18px 24px;
			font-size: 20px;
			font-weight: Bold;
			color: rgba(0, 0, 0, 0.85);
		}
		.box {
			padding: 24px;
			width: 100%;
			height: calc(100% - 64px);
		}
		.notifcation_main {
			position: relative;
			width: 100%;
			height: 100%;
			// max-height: 100%;
			border-radius: 2px;
			background: #ffffff;
			padding-bottom: 10px;
			box-sizing: border-box;
			overflow: hidden;
			.nav {
				width: 100%;
				padding: 0 24px;
				height: 52px;
				background: #ffffff;
				padding: 15px 24px;
				position: relative;
				::v-deep {
					.el-tabs__item:hover {
						color: #e60000;
					}
					.el-tabs__item.is-active {
						color: #e60000;
					}
					.el-tabs__active-bar {
						background: #e60000;
					}
				}
				.right {
					position: absolute;
					z-index: 6;
					top: 10px;
					right: 24px;
					width: 88px;
					height: 100%;
					.btn {
						width: 88px;
						height: 32px;
						padding: 6px 16px;
						display: inline-block;
						border: 1px solid #e60000;
						border-radius: 2px;
						background: none;
						color: #e60000;
						cursor: pointer;
					}
				}
			}
			.content {
				width: 100%;
				max-height: calc(100% - 104px);
				min-height: 565px;
				overflow-y: auto;
				padding: 24px 24px 0;
				.no_info {
					display: block;
					width: 100%;
					padding-top: 50px;
					box-sizing: border-box;
					text-align: center;
					font-size: 16px;
					font-weight: 400;
					color: #999999;
				}
				.info_item:hover {
					background-color: #eee;
				}
				.info_item {
					width: 100%;
					height: 54px;
					border-bottom: 1px solid #e9e9e9;
					line-height: 54px;
					display: flex;
					justify-content: space-between;
					font-size: 14px;
					.info_content {
						max-width: 800px;
						color: #333333;
						position: relative;
						margin-right: 15px;
						span {
							cursor: pointer;
							display: inline-block;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
						.sign_box {
							position: absolute;
							right: -7px;
							top: 50%;
							transform: translateY(-50%);
							width: 6px;
							height: 6px;
							background: #e60000;
							border-radius: 50%;
						}
					}
					.info_right {
						display: flex;
						.timer {
							min-width: 140px;
							// margin-right: calc(var(--proportion) * 79px);
						}
					}
					.timer {
						color: #999999;
						margin-right: 79px;
					}
					.info_btn {
						color: #e60000;
					}
					.el_btn {
						background: transparent;
						border: none;
						color: #e60000;
					}
				}
			}
		}
	}

	// 分页
	.footer {
		// position: absolute;
		// bottom: 0;
		// right: 24px;
		margin-top: 24px;
		padding-right: 24px;
		display: flex;
		justify-content: flex-end;
	}
	// 弹出框
	::v-deep .el-drawer .rtl {
		width: 780px;
	}
	.drawer {
		.header {
			width: 100%;
			height: 54px;
			padding: 16px 0 16px 32px;
			border-bottom: 1px solid #e9e9e9;
			display: flex;
			position: relative;
			.shut {
				position: absolute;
				right: 32px;
				top: 10px;
				cursor: pointer;
			}
			span {
				font-size: 16px;
				font-weight: bold;
			}
		}
		.mian {
			padding: 31px 32px;
			.title {
				margin-bottom: 16px;
				font-size: 20px;
				font-weight: 700;
			}
			.timer {
				margin-bottom: 32px;
				color: #333333;
				font-size: 14px;
			}
		}
		.content {
			border-top: 1px solid #e9e9e9;
			padding-top: 48px;
			font-size: 16px;
			color: #333333;
			line-height: 36px;
		}
	}
	::v-deep {
		.el-pagination.is-background .el-pager li:not(.disabled) {
			background-color: #fff; // 进行修改未选中背景和字体
			border: 1px solid #d9d9d9;
			color: rgba(0, 0, 0, 0.65);
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #e60000; // 进行修改选中项背景和字体
			color: #ffffff;
		}
		.btn-prev,
		.btn-next {
			border: 1px solid #d9d9d9;
			background-color: #fff !important;
		}

		.el-tabs {
			position: relative;
			z-index: 6;
			background-color: #fff;
		}
		.el-tabs__item {
			font-size: 16px;
		}

		// 分页框
		// 数字
		.el-pagination.is-background .el-pager li {
			font-weight: 400;
		}

		// 每页条数框
		.el-select .el-input.is-focus .el-input__inner {
			border-color: $theme-color;
			border-radius: 4px;
		}
		.el-pagination__sizes .el-input .el-input__inner:hover {
			border-color: $theme-color;
		}
		.el-input__inner:focus {
			border-color: $theme-color;
		}

		// 页码框
		.el-date-table td.today span {
			color: $theme-color;
		}
	}
	.el-icon-close {
		transform: scale(0.5);
	}

	::v-deep {
		// 一键已读
		.el-button--danger.is-plain {
			background: #fff;
			border-color: $theme-color;
			color: $theme-color;
		}
		.el-button--danger.is-plain:hover {
			background: $theme-color;
			color: #fff;
		}
	}
</style>
